import gql from 'graphql-tag';

export const GET_DASHBOARD = gql`
  query GetDashboard($input: ExternalDashboardAdminInput!) {
    externalDashboards {
      result: externalAdminDashboard(input: $input) {
        error
        success
        entity {
          id
          name
          icon
          type
          externalId
          description
          createdDateTime
          updatedDateTime
        }
      }
    }
  }
`;
